import { render, staticRenderFns } from "./medical-form.vue?vue&type=template&id=c169d814&scoped=true"
import script from "./medical-form.vue?vue&type=script&lang=js"
export * from "./medical-form.vue?vue&type=script&lang=js"
import style0 from "./medical-form.vue?vue&type=style&index=0&id=c169d814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c169d814",
  null
  
)

export default component.exports